/*
Copyright MITSUBISHI Elec.
*/

// 時刻表示部品
// ---------------------------------------------------------
// 時分を編集する部品。
// 利用例)
//  var timeEditor = new BlenderTimeEditor("dateEditor", BlenderTimeEditorConstants.TIME_SET_30MIN);
//  timeEditor.init();
//  timeEditor.setHourValue("時"値);
//  timeEditor.setMinuteValue("分"値);
// ---------------------------------------------------------

/**
 * ##BlenderTimeEditor
 * 
 * @module BlenderTimeEditor
 * @class BlenderTimeEditor
 */

/** 
 * 分指定：1分刻み(00～59) 
 * 
 * @property {string} TIME_SET_FULL
 * @static
 * @final
 */
BlenderTimeEditorConstants.TIME_SET_FULL = '1';
/** 
 * 分指定：30分刻み(00,30) 
 * 
 * @property {string} TIME_SET_30MIN
 * @static
 * @final
 */
BlenderTimeEditorConstants.TIME_SET_30MIN = '2';
/** 
 * 分指定：30分刻み(48点) 
 * 
 * @property {string} TIME_SET_30MIN_48
 * @static
 * @final
 */
BlenderTimeEditorConstants.TIME_SET_30MIN_48 = '3';

/**
 * ##BlenderTimeEditor
 * 
 * @module BlenderTimeEditor
 * @class BlenderTimeEditorConstants
 * @constractor
 */
function BlenderTimeEditorConstants(){
}

/**
 * ##BlenderTimeEditor
 * 
 * @module BlenderTimeEditor
 * @class BlenderTimeEditor
 * @constractor
 * @module BlenderTimeEditor
 * @param tagId {string} 
 */
function BlenderTimeEditor(tagId) {
	BlenderTimeEditor(tagId, BlenderTimeEditorConstants.TIME_SET_FULL);
}

function BlenderTimeEditor(tagId, timeset) {
	this.tagId = tagId;
	this.baseTag = $("#"+tagId);

	this.hourTagId = tagId + "_hour";
	this.minuteTagId = tagId + "_minute";

	this.prefix = "";
	this.hourSuffix = "：";
	this.minuteSuffix = "";

	this.isEnableHour = true;
	this.isEnableMinute = true;

	this.minuteData = timeset;
	if (this.minuteData == BlenderTimeEditorConstants.TIME_SET_30MIN_48) this.isEnableMinute = false;

	this.handlers = {};

	this.targetObj = new Array();

	BlenderComponent.call(this, tagId, "blender");
}

//Extends
BlenderTimeEditor.inherit(BlenderComponent);

BlenderTimeEditor.prototype.init = function() {

	this.baseTag.append("<span id='" + this.tagId + "'/>");

	var prefixTag =  $("<span class='cond-param-label'/>");
	prefixTag.append(this.prefix);
	this.baseTag.append(prefixTag);

	if (this.isEnableHour) {
		var hw = (this.minuteData == BlenderTimeEditorConstants.TIME_SET_30MIN_48) ? 80 : 40;
		var hourTag = $("<select id='" + this.hourTagId + "' style='width:"+hw+"px;'/>");
		this.baseTag.append(hourTag);

		if (this.minuteData != BlenderTimeEditorConstants.TIME_SET_30MIN_48) {
			var hourSuffixTag =  $("<span class='cond-param-label'/>");

			hourSuffixTag.append(this.hourSuffix);
			this.baseTag.append(hourSuffixTag);
		}

		var hTag = $("#" + this.hourTagId);
		if (this.minuteData == BlenderTimeEditorConstants.TIME_SET_30MIN_48) {
			for (var i = 0; i <= 23; i++) {
				var hour;
				if (i < 10) {
					hour = "0" + i;
				} else {
					hour = new String(i);
				}

				hTag.append("<option value='" + hour + "00'>" + hour + ":00</option>");
				hTag.append("<option value='" + hour + "30'>" + hour + ":30</option>");
			}
		} else {
			for (var i = 0; i <= 23; i++) {
				var hour;
				if (i < 10) {
					hour = "0" + i;
				} else {
					hour = new String(i);
				}
	
				hTag.append("<option value='" + hour + "'>" + hour + "</option>");
			}
		}

		this.targetObj.push($("#" + this.hourTagId));
	}

	if (this.isEnableMinute) {
		var minuteTag = $("<select id='" + this.minuteTagId + "' style='width:40px;'/>");
		this.baseTag.append(minuteTag);

		var minuteSuffixTag =  $("<span class='cond-param-label'/>");
		minuteSuffixTag.append(this.minuteSuffix);
		this.baseTag.append(minuteSuffixTag);

		var mTag = $("#" + this.minuteTagId);

		if (this.minuteData == BlenderTimeEditorConstants.TIME_SET_30MIN) {
			mTag.append("<option value='00'>00</option>");
			mTag.append("<option value='30'>30</option>");
		} else {
			for (var i = 0; i <= 59; i++) {
				var minute;
				if (i < 10) {
					minute = "0" + i;
				} else {
					minute = new String(i);
				}
				mTag.append("<option value='" + minute + "'>" + minute + "</option>");
			}
		}

		this.targetObj.push($("#" + this.minuteTagId));
	}

	for ( var i = 0; i < this.targetObj.length; i++) {
		var obj = this.targetObj[i];
		var self = this;
		obj.change(function(){
			self._notifyEvent({type:"valueChanged", src:obj, value:obj.val()});
		});
	}
}



/**
 * 時コンボボックスの有効/無効を設定する。
 *
 * @param isEnableHour 時コンボボックスの有効/無効
 */
BlenderTimeEditor.prototype.setEnableHour = function(isEnableHour) {
	this.isEnableHour = isEnableHour;
}

/**
 * 分コンボボックスの有効/無効を設定する。
 *
 * @param isEnableMinute 分コンボボックスの有効/無効
 */
BlenderTimeEditor.prototype.setEnableMinute = function(isEnableMinute) {
	this.isEnableMinute = isEnableMinute;
}

// 接頭辞の設定
BlenderTimeEditor.prototype.setPrefix = function(val) {
	this.prefix = val;
}

// 接尾辞の設定
BlenderTimeEditor.prototype.setHourSuffix = function(val) {
	this.hourSuffix = val;
}

BlenderTimeEditor.prototype.setMinuteSuffix = function(val) {
	this.minuteSuffix = val;
}

// "時"値の取得
BlenderTimeEditor.prototype.getHourValue = function() {
	if (this.minuteData == BlenderTimeEditorConstants.TIME_SET_30MIN_48) {
		return $("#" + this.hourTagId).val().slice(0,2);
	} else {
		return $("#" + this.hourTagId).val();
	}
}

// "時"値の設定
BlenderTimeEditor.prototype.setHourValue = function(val) {
	if (this.minuteData == BlenderTimeEditorConstants.TIME_SET_30MIN_48) {
		$("#" + this.hourTagId).val(val+"00");
	} else {
		$("#" + this.hourTagId).val(val);
	}
}

// "分"値の取得
BlenderTimeEditor.prototype.getMinuteValue = function() {
	if (this.minuteData == BlenderTimeEditorConstants.TIME_SET_30MIN_48) {
		return $("#" + this.hourTagId).val().slice(2,2);
	} else {
		return $("#" + this.minuteTagId).val();
	}
}

// "分"値の設定
BlenderTimeEditor.prototype.setMinuteValue = function(val) {
	if (this.minuteData == BlenderTimeEditorConstants.TIME_SET_30MIN_48) {
		$("#" + this.hourTagId).val(this.getHourValue()+val);
	} else {
		$("#" + this.minuteTagId).val(val);
	}
}

// Dateの設定
BlenderTimeEditor.prototype.setDate = function(date) {
	var hour = date.getHours() + ""; // 時
	var min = date.getMinutes() + ""; // 分

	if (this.minuteData == BlenderTimeEditorConstants.TIME_SET_30MIN) {
		if (date.getMinutes() < 30) {
			min = "0";
		} else {
			min = "30";
		}
	}

	var adjust = function(val) {
		return (val.length == 2 ? val : "0" + val);
	}


	lastTime.val(adjust(hour) + ":" + adjust(min));
}

// 値の変更時に実行される関数
BlenderTimeEditor.prototype.setOnChangeValue =
	function(func) {
		$("#" + this.hourTagId).change(func);
		$("#" + this.minuteTagId).change(func);
	}

// 時を変更したときのイベントを実行する。
BlenderTimeEditor.prototype.changeHour = function() {
	$("#" + this.hourTagId).change();
}

/**
 * 変更チェッカーの設定を行う。
 *
 * @param modifyChecker 変更チェッカーオブジェクト
 */
BlenderTimeEditor.prototype.addModifyCheckerTarget = function(modifyChecker) {
	modifyChecker.addTarget($("#" + this.hourTagId));
	modifyChecker.addTarget($("#" + this.minuteTagId));
}

/**
 * 変更チェッカーより保存された時の値を取得する。
 */
BlenderTimeEditor.prototype.getSavedHourVal = function() {
	return $("#" + this.hourTagId).savedVal();
}

/**
 * 変更チェッカーより保存された分の値を取得する。
 */
BlenderTimeEditor.prototype.getSavedMinuteVal = function() {
	return $("#" + this.minuteTagId).savedVal();
}

/**
 * 要素に属性を設定する。
 * @param name 属性の名前
 * @param value 属性の値
 */
BlenderTimeEditor.prototype.attr = function(name, value) {
	for(var i = 0; i < this.targetObj.length; i++){
		var obj = this.targetObj[i];
		obj.attr(name, value);
	}
}

/**
 * 要素から属性を削除する。
 * @param name 属性の名前
 */
BlenderTimeEditor.prototype.removeAttr = function(name) {
	for(var i = 0; i < this.targetObj.length; i++){
		var obj = this.targetObj[i];
		obj.removeAttr(name);
	}
}

/**
 * 値を取得/設定する。
 * ※BlenderModifyChecker対応用メソッド
 * @param value 値
 * @return 値
 */
BlenderTimeEditor.prototype.val = function(value) {
	if ( value === undefined ) {
		var ret = new Array();
		for(var i = 0; i < this.targetObj.length; i++){
			var obj = this.targetObj[i];
			ret.push(obj.val());
		}
		return ret.join(":");
	} else {
		var array = value.split(":");
		for(var i = 0; i < array.length; i++){
			this.targetObj[i].val(array[i]);
		}
	}
}

/**
 * 保存値を取得/設定する。
 * ※BlenderModifyChecker対応用メソッド
 * @param value 値
 * @return 値
 */
BlenderTimeEditor.prototype.savedVal = function(value) {
	if ( value === undefined ) {
		var ret = new Array();
		for(var i = 0; i < this.targetObj.length; i++){
			var obj = this.targetObj[i];
			ret.push(obj.savedVal());
		}
		return ret.join(":");
	} else {
		var array = value.split(":");
		for(var i = 0; i < array.length; i++){
			this.targetObj[i].savedVal(array[i]);
		}
	}
}

/**
 * クラスの有無を確認する。
 * ※BlenderModifyChecker対応用メソッド
 * @param className クラス名
 */
BlenderTimeEditor.prototype.hasClass = function(className) {
	var ret = true;
	for(var i = 0; i < this.targetObj.length; i++){
		var obj = this.targetObj[i];
		ret &= obj.hasClass(className);
	}
	return ret;
}

/**
 * クラスを追加する。
 * ※BlenderModifyChecker対応用メソッド
 * @param className クラス名
 */
BlenderTimeEditor.prototype.addClass = function(className) {
	for(var i = 0; i < this.targetObj.length; i++){
		var obj = this.targetObj[i];
		obj.addClass(className);
	}
}

/**
 * クラスを削除する。
 * ※BlenderModifyChecker対応用メソッド
 * @param className クラス名
 */
BlenderTimeEditor.prototype.removeClass = function(className) {
	for(var i = 0; i < this.targetObj.length; i++){
		var obj = this.targetObj[i];
		obj.removeClass(className);
	}
}

/**
 * 空実装
 */
BlenderTimeEditor.prototype.focus = function() {

}

/**
 * 空実装
 */
BlenderTimeEditor.prototype.blur = function() {

}

/**
 * 値変更イベントハンドラを設定する。
 * ※BlenderModifyChecker対応用メソッド
 * @param func 値変更イベントハンドラ
 */
BlenderTimeEditor.prototype.change = function(func) {
	this.attachEvent("valueChanged", func);
}

/**
 * 開始日時と終了日時を調整する。
 * 開始日を変更した場合に、開始日より終了日のほうが若い場合、終了日を開始日と同値にする。
 * 終了日を変更した場合に、開始日より終了日のほうが若い場合、開始日を終了日と同値にする。
 * 開始時刻を変更した場合に、開始時間帯より終了時間帯のほうが若い場合、開始時間帯を終了時間帯と同値にする。
 * 終了時刻を変更した場合に、開始時間帯より終了時間帯のほうが若い場合、終了時間帯を開始時間帯と同値にする。
 *
 * @param firstCal 開始日
 * @param firstTime 開始時刻
 * @param lastCal 終了日
 * @param lastTime 終了時刻
 */
BlenderTimeEditor.buildAdjustCalendarTime = function(firstCal, firstTime, lastCal, lastTime) {
	// 日付入力の開始日、終了日の補正処理設定
	firstCal.setAfterCalendar(lastCal);
	lastCal.setBeforeCalendar(firstCal);

	firstCal.change(function(){
		lastTime._notifyEvent({type:"valueChanged", src:self, value:lastTime.val()});
	});

	lastCal.change(function(){
		firstTime._notifyEvent({type:"valueChanged", src:self, value:firstTime.val()});
	});

	firstTime.change(function(){
		if(firstCal.val() == lastCal.val() && lastTime.val() < firstTime.val()){
			lastTime.val(firstTime.val());
		}
	});

	lastTime.change(function(){
		if(firstCal.val() == lastCal.val() && lastTime.val() < firstTime.val()){
			firstTime.val(lastTime.val());
		}
	});
}

/*
Copyright MITSUBISHI Elec.
*/
